"use client";

import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Lottie from "lottie-react";
import unLockAnimation from "../../../../../public/next_assets/lottie/un-locked.json";
import Image from "next/image";

type Step = "initial" | "swap" | "settled" | "lottie";

export default function CardStackAnimation() {
  const [step, setStep] = useState<Step>("initial");
  const [mounted, setMounted] = useState<boolean>(false);

  useEffect(() => {
    setMounted(true);

    const t1 = setTimeout(() => setStep("swap"), 800);
    const t2 = setTimeout(() => setStep("settled"), 1600);
    const t3 = setTimeout(() => setStep("lottie"), 2200);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, []);

  return (
    <>
      {/* BACK CARD */}
      <motion.img
        src="next_assets/images/portfolio-services/animated-card-step-2.png"
        alt="back"
        className="w-44 sm:w-54 opacity-40 origin-center animate-pulse"
        initial={false}
        animate={step === "initial" ? { rotate: -7, scale: 0.95 } : { rotate: 0, scale: 1 }}
        transition={{
          duration: mounted ? 0.6 : 0,
          ease: "easeInOut",
        }}
      />

      {/* FRONT CARD */}
      <motion.div
        className="absolute left-0 top-0 w-full"
        initial={false}
        animate={step === "initial" ? { y: 70, x: -20 } : { y: 50, x: 5 }}
        transition={{
          duration: mounted ? 0.6 : 0,
          ease: "easeInOut",
        }}
      >
        <Image
          src="/next_assets/images/portfolio-services/animated-bank-card-step-2.png"
          alt="front"
          width={300}
          height={200}
          className="object-contain w-64"
        />

        {/* LOTTIE */}
        {step === "lottie" && (
          <motion.div
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4 }}
            className="absolute inset-0 flex items-center justify-center"
          >
            <div className="w-14 h-14 sm:w-16 sm:h-16 p-1.5 sm:p-2 rounded-full border border-white/30 bg-white/60 flex items-center justify-center">
              <Lottie animationData={unLockAnimation} loop />
            </div>
          </motion.div>
        )}
      </motion.div>
    </>
  );
}
